import { useLanguageContext } from "@/hooks";
import { swapLabel } from "@/utility";

export default function BreadCrumb({ crumbs }) {

    const { language } = useLanguageContext();

    return (
        <p id="breadcrumbid" className="page_titall">
            {
                crumbs?.map((crumb, index) => {
                    if (crumb) {
                        let labelText = language(swapLabel(crumb)) ?? crumb;
                        if (
                            typeof labelText === 'string' &&
                            labelText.trim().toLowerCase() === 'property dealer'
                        ) {
                            labelText = 'Property';
                        } else if (
                            typeof crumb === 'string' &&
                            (crumb.trim().toLowerCase() === 'property dealer' || crumb.trim().toLowerCase() === 'category.property_dealer')
                        ) {
                            labelText = 'Property';
                        }

                        return <span className="text-capitalize" key={index}>
                            {labelText} {
                                index < crumbs.length - 1 && <i className="fas fa-chevron-right mr-2" ></i>
                            }
                        </span>
                    }
                    return null
                }
                )
            }
        </p>
    );
}